/**
 * How a person reads dates and times (AIOE 0.71.0): the clock, the order of a numeric date and the first day of the
 * week, the choices of the AI Workbench's Settings › General › Date and time (`display.clock`, `display.dateOrder`,
 * `display.weekStart`; the workbench's shared/wording/dateTime.ts). One set per person per organisation, so the
 * workbench, the console and the phone write a time the same way:
 *
 *   GET /people/v1/me/display   -> DisplayPreferences   (a sign-in or the person's desktop token)
 *   PUT /people/v1/me/display   DisplayPreferencesInput -> DisplayPreferences
 *
 * "system" means the reader's own computer or phone decides (its region, or on a desktop the operating system's own
 * clock and date order). The workbench pushes its choices here when they change and, at sign-in, takes these while
 * its own are still "system". The time zone is not here: it is the person's notification preferences' `timeZone`.
 */
import { z } from "zod";
export const DISPLAY_PREFERENCES_PATH = "/people/v1/me/display";
export const clockPrefSchema = z.enum(["system", "12h", "24h"]);
export const dateOrderPrefSchema = z.enum(["system", "dmy", "mdy", "ymd"]);
export const weekStartPrefSchema = z.enum(["system", "monday", "sunday"]);
/** What a PUT sends; a field left out is "system". */
export const displayPreferencesInputSchema = z.object({
    clock: clockPrefSchema.default("system"),
    dateOrder: dateOrderPrefSchema.default("system"),
    weekStart: weekStartPrefSchema.default("system"),
});
export const DEFAULT_DISPLAY_PREFERENCES = { clock: "system", dateOrder: "system", weekStart: "system" };
//# sourceMappingURL=displayPreferences.js.map